import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import "./AdmissionsPage.css";
import SchoolInnerPageBanner from "../../components/SchoolInnerPageBanner";
import AdmissionApplicationForm from "../../components/AdmissionApplicationForm";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const SchoolAdmissionPage = () => {
  const { school_slug } = useParams();
  const location = useLocation();

  const [loading, setLoading] = useState(true);

  const [admissionOverview, setadmissionOverview] = useState(null);

  const [criteria, setCriteria] = useState(null);
  const [rows, setRows] = useState([]);


  const [procedure, setProcedure] = useState(null);
  const [lists, setLists] = useState([]);
  const [image, setImage] = useState("");

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  useEffect(() => {
    scrollToTop();
  }, []);

  //  
  useEffect(() => {
    if (!school_slug) return;
    fetchAdmissionOverview();
    fetchCriteria();
    fetchProcedure();
  }, [school_slug]);


  /* ------------------ Admission Overview --------------- */
  const fetchAdmissionOverview = async () => {
    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/admission_page/get_admission_overview_content/${school_slug}`,
        { withCredentials: true }
      );

      if (res.data.status === 1) {
        setadmissionOverview(res.data.data.section);
      }
    } catch (error) {
      console.error("Criteria API error:", error);
    }
  };


  /* ---------------- FETCH CRITERIA DATA ---------------- */
  const fetchCriteria = async () => {
    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/admission_page/get_criteria_section/${school_slug}`,
        { withCredentials: true }
      );

      console.log("API RESPONSE:", res.data);

      if (res.data.status === 1) {
        setCriteria(res.data.data.criteria_section);
        setRows(res.data.data.criteria_table);

      }
    } catch (error) {
      console.error("Criteria API error:", error);
    }
  };


  /* ---------------- FETCH APPLICATION PROCEDURE DATA ---------------- */
  const fetchProcedure = async () => {
    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/admission_page/get_admission_procedure_section/${school_slug}`
      );

      console.log("PROCEDURE API FULL RESPONSE:", res.data);

      if (
        res.data.status === 1 &&
        res.data.data &&
        res.data.data.section
      ) {
        setProcedure(res.data.data.section);
        setLists(res.data.data.lists || []);
      } else {
        setProcedure(null);
        setLists([]);
      }
    } catch (err) {
      console.error("Procedure error:", err);
      setProcedure(null);
      setLists([]);
    }
  };



  const groupedLists = lists.reduce((acc, item) => {
    if (!acc[item.title]) {
      acc[item.title] = [];
    }
    acc[item.title].push(item.content);
    return acc;
  }, {});

  // For Criteria
  const hasCriteriaSection =
    criteria &&
    (
      criteria.heading ||
      criteria.description ||
      (Array.isArray(rows) && rows.length > 0) ||
      criteria.note_1 ||
      criteria.note_2
    );

  const [uniforms, setUniforms] = useState(null);

  useEffect(() => {
    fetchUniforms();
  }, []);

  const fetchUniforms = async () => {
    try {
      const res = await axios.get(
        `${baseAPIUrl}api/admission/get_school_uniform/${school_slug}`
      );

      if (res.data.status === 1) {
        setUniforms(res.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const UniformTable = ({ title, season, gender }) => {
    const rows = uniforms?.[season]?.[gender];

    if (!rows || rows.length === 0) return null;

    return (
      <div className="school-uniform-block">
        {title && <h3 className="school-uniform-subtitle">{title}</h3>}

        <h2 className="school-uniform-title">
          {gender.charAt(0).toUpperCase() + gender.slice(1)}
        </h2>

        <table className="school-uniform-table" style={{ background: "#ffffff" }}>
          <thead>
            <tr>
              <th className="school-uniform-header">Class</th>
              <th className="school-uniform-header">
                {season === "summer"
                  ? "Summer Uniform Particulars"
                  : "Winter Uniform Particulars"}
              </th>
            </tr>
          </thead>

          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td className="school-uniform-cell">{row.class_range}</td>
                <td className="school-uniform-cell">{row.particulars}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };


  return (
    <>
      <div className="admissions-page">
        {/* ---------------- HERO SECTION ---------------- */}
        {/* Hero Section */}
        <SchoolInnerPageBanner />

        {/* Admission Overview */}

        {/* 🔹 ABOUT SECTION */}
        {admissionOverview?.heading && (
          <section id="admission-overview"
            style={{
              padding: "80px 20px",
              background: "rgb(100, 19, 32)",
              color: "white",
            }}
          >
            <div className="container" style={{ maxWidth: "1200px", margin: "0 auto" }}>
              <div className="row align-items-center">

                {/* TEXT */}
                <div className="col-lg-12">
                  {admissionOverview?.heading && (
                    <h2 style={headingStyleForRGB}>{admissionOverview?.heading}</h2>
                  )}

                  {admissionOverview?.admission_overview_content && <p style={{ whiteSpace: "pre-line" }}>{admissionOverview.admission_overview_content}</p>}
                </div>
              </div>
            </div>
          </section>
        )}


        {/* Admission Application Procedure Section */}
        {procedure?.heading && (
          <section id="admission-application-procedurer" style={{ padding: "80px 20px", background: "#f8f9fa" }}>
            <div style={{ maxWidth: "1200px", margin: "0 auto" }}>

              <h2 style={headingStyle}>{procedure?.heading}</h2>

              <p style={descStyle}>{procedure?.intro_paragraph}</p>

              <div className="mv-wrapper-admission" style={{marginBottom: '30px'}}>
                <div className="mv-box-admission">
                  <h4 style={boxTitle}>{procedure?.manual_title}</h4>
                  <p className="admission-procedure-p">{procedure?.manual_content}</p>
                </div>

                <div className="mv-box-admission">
                  <h4 style={boxTitle}>{procedure?.online_title}</h4>
                  <p className="admission-procedure-p">{procedure?.online_content}</p>
                </div>
              </div>


              {/* MENU / LISTS */}
              {Object.keys(groupedLists).length > 0 && (
                Object.keys(groupedLists).map((title, index) => (
                  <div key={index} style={whiteBoxs}>
                    <h4 style={boxTitle}>{title}</h4>

                    <ul className="admission-procedure-p" style={{ paddingLeft: "20px", marginTop: "10px" }}>
                      {groupedLists[title].map((text, i) => (
                        <li
                          key={i}
                          style={{ marginBottom: "8px", lineHeight: "1.6" }}
                        >
                          {text}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))
              )}


              <div style={{ background: 'rgb(100, 19, 32)', color: 'white', padding: '20px', borderRadius: '10px', textAlign: 'center', marginBottom: '40px' }}>
                <h4 style={{ fontSize: '1.2rem', marginBottom: '10px', fontFamily: 'Lora' }}>{procedure?.withdrawal_title}</h4>
                <p className="admission-procedure-p">{procedure?.withdrawal_content}</p>
              </div>

              {procedure?.image && procedure.image.trim() !== "" && (
                <div style={{ textAlign: "center" }}>
                  <img
                    src={`${baseAPIUrl}assets/images/admission/${procedure.image}?t=${Date.now()}`}
                    alt="Admission Open"
                    style={{
                      maxWidth: "600px",
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
              )}
            </div>
          </section>
        )}

        {/* Criteria Section */}
        {hasCriteriaSection && (
          <section id="criteria" style={{ padding: "80px 20px", background: "white" }}>
            <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
              {criteria?.heading && (
                <h2 style={headingStyle}>{criteria.heading}</h2>
              )}

              {criteria?.description && (
                <p style={descStyle}>{criteria.description}</p>
              )}

              {Array.isArray(rows) && rows.length > 0 && (
                <div style={{ display: "flex", justifyContent: "center", marginBottom: "30px" }}>
                  <table style={tableStyle}>
                    <thead>
                      <tr style={{ backgroundColor: '#f8f9fa' }}>
                        <th className="thStyle">Class</th>
                        <th className="thStyle">Age Group</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, index) => (
                        <tr key={index}>
                          <td className="tdStyle">{row.class_name}</td>
                          <td className="tdStyle">{row.age_group}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {criteria?.note_1 && (
                <p style={noteStyle}>{criteria?.note_1}</p>
              )}

              {criteria?.note_2 && (
                <p style={noteStyle}>{criteria?.note_2}</p>
              )}
            </div>
          </section>

        )}


        {/* School Uniform */}

        <section id="school-uniform" style={{ padding: '80px 20px', background: 'rgb(100, 19, 32)', color: 'white' }}>
          <div className="container">
            <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}>SCHOOL UNIFORM</h2>
            <div className="school-uniform-container">

              <UniformTable
                title="Uniform Details – Summer"
                season="summer"
                gender="boys"
              />
              <UniformTable season="summer" gender="girls" />

            </div>
            <div className="school-uniform-container">

              <div className="school-uniform-container">
                <UniformTable
                  title="Uniform Details – Winter"
                  season="winter"
                  gender="boys"
                />
                <UniformTable season="winter" gender="girls" />
              </div>

            </div>
          </div>
        </section>


        {/* Application Form Section */}
        <AdmissionApplicationForm/>
      </div>

    </>
  );
};

/* ===== STYLES ===== */
const container = { maxWidth: 1200, margin: "0 auto" };
const sectionWhite = {
  padding: "40px 20px",
  background: "#fff",
};
const sectionGrey = {
  padding: "40px 20px",
  background: "#f8f9fa",
};
const headingStyle = {
  fontSize: "2.5rem",
  fontWeight: "600",
  color: "rgb(100, 19, 32)",
  textAlign: "center",
  marginBottom: "30px",
  fontFamily: "Lora"
};
const headingStyleForRGB = {
  fontSize: "2.5rem",
  color: "#fff",
  textAlign: "center",
  marginBottom: "30px",
  fontFamily: "Lora"
};
const descStyle = {
  fontSize: "1.1rem",
  lineHeight: "1.8",
  color: "#333",
  marginBottom: "30px",
  fontFamily: "Lora",
  textAlign: "center",
};
const introStyle = {
  fontSize: "1rem",
  lineHeight: 1.7,
  marginBottom: 30,
};
const tableStyle = {
  backgroundColor: 'white',
  border: '2px solid rgb(100, 19, 32)',
  borderCollapse: "collapse",
  width: "100%",
  maxWidth: "600px",
  color: '#333',
  borderRadius: '10px',
  overflow: 'hidden',
  fontFamily: 'Lora',
};

const noteStyle = {
  textAlign: "center",
  color: "#666",
  lineHeight: '1.6',
  textAlign: 'center',
  marginBottom: '10px',
};

const whiteBox = {
  background: "#fff",
  padding: 25,
  borderRadius: 10,
  border: "2px solid rgb(100,19,32)",
  marginBottom: 25,
  height: "320px"
};

const whiteBoxs = {
  background: "#fff",
  padding: 25,
  borderRadius: 10,
  border: "2px solid rgb(100,19,32)",
  marginBottom: 25,
};

const boxTitle = {
  fontSize: "1.2rem",
  fontFamily: "Lora",
  color: "rgb(100,19,32)",
  fontWeight: 600,
  marginBottom: 10,
};
export default SchoolAdmissionPage;